import axios from "axios";
import { baseUrl, redirectUrl } from "src/config";

const axiosInstance = axios.create({
  baseURL: baseUrl,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 440) {
      window.dispatchEvent(new Event("session-expired"));
      return new Promise(() => {});
    }
    if (error.response && error.response.status === 403) {
      window.location.href = redirectUrl;
    }
    return Promise.reject(error);
  },
);

export default axiosInstance;
